/*
 * @Description: 请求封装
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-20 13:59:14
 * @LastEditTime: 2019-07-26 17:07:04
 */
import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import ServerErr from '@/utils/ServerErr'
import { LOGISTICE_BASEAPI, AUTHORIZATION_BASEAPI, LOGISTICE_GATEWAY, AUTHORIZATION_GATEWAY } from './settings'

const listArr = [`${AUTHORIZATION_GATEWAY}/auth/oauth/token`, `${LOGISTICE_GATEWAY}/youThing/loveSomething`, `${LOGISTICE_GATEWAY}/youThing/coolSomething`] // 不需要处理格式的接口

// 本户网站接口
const logistice = axios.create({
  baseURL: LOGISTICE_BASEAPI
})
logistice.interceptors.request.use(headerQequest, headerQequestErr)
logistice.interceptors.response.use(herderResponse, headerResponseError)

// 登录接口（微服务）
const authorization = axios.create({
  baseURL: AUTHORIZATION_BASEAPI
})
authorization.interceptors.request.use(headerQequest, headerQequestErr)
authorization.interceptors.response.use(herderResponse, headerResponseError)

/**
 * @description: 请求拦截处理参数
 * @param { Object } config
 * @return: Object
 */
function headerQequest(config) {

  if (listArr.indexOf(config.url) === -1) {
    if (config.method !== 'get') {
      if (!config.data) {
        console.warn(`接口${config.url}axios参数params已经废弃请参考 api/user.js 里边的 getInfo 方法`)
        if (typeof config.params.params === 'string') {
          config.data = JSON.parse(config.params.params || config.params)
        } else {
          config.data = config.params.params || config.params
        }
        delete config.params // 删除params 参数
      }
    }
  }
  // 在发送请求之前做点什么
  config.headers['Content-Type'] = 'application/json;charset=utf-8'
  if (!config.headers['Authorization']) { // 如果没有自定义请求头，需要携带token
    if (store.getters.token) {
      config.headers['Authorization'] = `bearer ${getToken()}` // 让每个请求携带自定义token
    }
  }
  return config
}

/**
 * @description: 处理请求错误
 * @param {Object} error
 * @return: Promese
 */
function headerQequestErr(error) {
  console.log("headerQequestErr")
  return Promise.reject(error)
}

/**
 * @description: 响应拦截处理参数
 * @param {response} Object
 * @return: Promise || Object
 */
function herderResponse(response) {
 console.log("herderResponse")
  const res = response.data
  // 登录接口单独处理, 添加code
  if (res.access_token) {
    res.code = 200
  }
 console.log(res.cod)

  // 如果自定义代码不是200，则判断为错误。
  if (res.code == 0) {
    return res
  } else if (res.code !== 200) {
    Message({
      message: res.message || '请求报错',
      offset: 100,
      type: 'error',
      duration: 5 * 1000
    })

    // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
    if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      // 重新登录
      MessageBox.confirm('您已注销，可以取消以留在此页，或重新登录。', '确认注销', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('user/resetToken').then(() => {
          location.reload()
        })
      })
      console.log(res.code)
    }
    return Promise.reject(new Error(res.message || '请求报错'))
  } else {
    return res
  }
}

/**
 * @description: 响应错误拦截
 * @param {Object} error
 * @return: Promise
 */
function headerResponseError(error) {
console.log(error)
  if (error && error.response) {
    const message = ServerErr(error.response)
     console.log(message)
    Message({
      message,
      offset: 100,
      type: 'error',
      duration: 5 * 1000
    })
  }
  return Promise.reject(error)
}

export { logistice, authorization }
